/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentsPerVehicle
 */
export interface IncidentsPerVehicle {
    /**
     * 
     * @type {string}
     * @memberof IncidentsPerVehicle
     */
    vehicleId: string;
    /**
     * 
     * @type {number}
     * @memberof IncidentsPerVehicle
     */
    totalDriveSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof IncidentsPerVehicle
     */
    incidents: number;
    /**
     * 
     * @type {string}
     * @memberof IncidentsPerVehicle
     */
    vehicleModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IncidentsPerVehicle
     */
    vehicleManufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IncidentsPerVehicle
     */
    vehicleSerialNumber?: string | null;
}

/**
 * Check if a given object implements the IncidentsPerVehicle interface.
 */
export function instanceOfIncidentsPerVehicle(value: object): value is IncidentsPerVehicle {
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('totalDriveSeconds' in value) || value['totalDriveSeconds'] === undefined) return false;
    if (!('incidents' in value) || value['incidents'] === undefined) return false;
    return true;
}

export function IncidentsPerVehicleFromJSON(json: any): IncidentsPerVehicle {
    return IncidentsPerVehicleFromJSONTyped(json, false);
}

export function IncidentsPerVehicleFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentsPerVehicle {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleId': json['vehicleId'],
        'totalDriveSeconds': json['totalDriveSeconds'],
        'incidents': json['incidents'],
        'vehicleModel': json['vehicleModel'] == null ? undefined : json['vehicleModel'],
        'vehicleManufacturer': json['vehicleManufacturer'] == null ? undefined : json['vehicleManufacturer'],
        'vehicleSerialNumber': json['vehicleSerialNumber'] == null ? undefined : json['vehicleSerialNumber'],
    };
}

export function IncidentsPerVehicleToJSON(json: any): IncidentsPerVehicle {
    return IncidentsPerVehicleToJSONTyped(json, false);
}

export function IncidentsPerVehicleToJSONTyped(value?: IncidentsPerVehicle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleId': value['vehicleId'],
        'totalDriveSeconds': value['totalDriveSeconds'],
        'incidents': value['incidents'],
        'vehicleModel': value['vehicleModel'],
        'vehicleManufacturer': value['vehicleManufacturer'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
    };
}

